/* Heevis Shopify theme — vanilla JS for interactive bits.
   No framework, no build step. Targets evergreen browsers. */

(function () {
  'use strict';

  // ── Helpers ───────────────────────────────────────────────────────────────
  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]));
  }
  function formatMoney(cents) {
    return new Intl.NumberFormat(window.HV_LOCALE || 'nl-NL',
      { style: 'currency', currency: window.HV_CURRENCY || 'EUR' }).format((cents || 0) / 100);
  }
  function debounce(fn, ms) {
    let t; return function (...a) { clearTimeout(t); t = setTimeout(() => fn.apply(this, a), ms); };
  }

  // ── Actieprijs (thema-instellingen > Actieprijs) ──────────────────────────
  // window.hvPromo komt uit snippets/promo-head.liquid (alleen als de actie loopt). Liquid tekent
  // de actieprijs al op productkaarten en de productpagina; dit deel doet hetzelfde voor kaarten
  // die met JavaScript worden opgebouwd (zoeken, aanbevelingen, recent bekeken, upsells).
  // Het kortingsbedrag wordt naar beneden afgerond op centen, net als Shopify's automatische
  // korting (42900 -> 37752, 2999 -> 2640).
  function hvPromoOn() {
    const P = window.hvPromo;
    if (!P || document.documentElement.classList.contains('hv-promo-off')) return false;
    const n = Date.now();
    return n >= P.start && n <= P.end;
  }
  function hvPromoCents(cents, pct) { return cents - Math.floor(cents * pct / 100); }
  function hvPromoEuroText(t) {
    let s = String(t || '').replace(/[^\d,.-]/g, '');
    if (s.indexOf(',') > -1) s = s.replace(/\./g, '').replace(',', '.');
    const n = parseFloat(s);
    return isNaN(n) ? 0 : Math.round(n * 100);
  }
  function hvPromoMoney(cents) { return '€' + (cents / 100).toFixed(2).replace('.', ','); }
  function hvPromoScan(root) {
    if (!hvPromoOn()) return;
    const P = window.hvPromo;
    (root || document).querySelectorAll('a[href*="/products/"]').forEach(a => {
      if (a.dataset.hvPromoDone) return;
      const m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if (!m) return;
      let h = m[1]; try { h = decodeURIComponent(h); } catch (e) {}
      if (P.handles.indexOf(h) < 0) return;
      const el = a.querySelector('[data-hv-price], .hv-product-card__price .price');
      if (!el || el.closest('[data-hv-promo]')) return;
      const cents = hvPromoEuroText(el.textContent);
      if (!cents) return;
      a.dataset.hvPromoDone = '1';
      el.textContent = hvPromoMoney(hvPromoCents(cents, P.pct));
      el.classList.add('hv-pp__new');
      const old = document.createElement('span');
      old.className = 'compare-at hv-pp__old';
      old.textContent = hvPromoMoney(cents);
      el.after(old);
      if (P.label) {
        const b = document.createElement('span');
        b.className = 'hv-pp__badge';
        b.textContent = P.label;
        old.after(b);
      }
    });
  }
  window.hvPromoScan = hvPromoScan;
  if (window.hvPromo) {
    hvPromoScan(document);
    const promoRescan = debounce(() => hvPromoScan(document), 60);
    new MutationObserver(muts => {
      if (muts.some(m => m.addedNodes && m.addedNodes.length)) promoRescan();
    }).observe(document.body, { childList: true, subtree: true });
  }

  // ── A11y: aria-live announce ─────────────────────────────────────────────
  function announce(msg, urgent) {
    const el = document.getElementById(urgent ? 'hv-live-alert' : 'hv-live');
    if (!el) return;
    el.textContent = ''; setTimeout(() => { el.textContent = msg; }, 50);
  }

  // ── A11y: focus trap for modals ──────────────────────────────────────────
  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  function trapFocus(container) {
    if (!container) return () => {};
    const previouslyFocused = document.activeElement;
    const focusables = Array.from(container.querySelectorAll(FOCUSABLE))
      .filter(el => el.offsetWidth > 0 || el.offsetHeight > 0);
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    function onKey(e) {
      if (e.key !== 'Tab') return;
      if (focusables.length === 0) { e.preventDefault(); return; }
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', onKey);
    if (first) setTimeout(() => first.focus(), 30);
    return () => {
      container.removeEventListener('keydown', onKey);
      if (previouslyFocused && previouslyFocused.focus) previouslyFocused.focus();
    };
  }

  // ── Toasts ────────────────────────────────────────────────────────────────
  function toast(msg, kind) {
    const host = document.querySelector('[data-toasts]');
    if (!host) { console.log('[toast]', msg); return; }
    const t = document.createElement('div');
    t.className = 'hv-toast hv-toast--' + (kind || 'success');
    t.textContent = msg;
    host.appendChild(t);
    requestAnimationFrame(() => t.classList.add('is-in'));
    setTimeout(() => { t.classList.remove('is-in');
      setTimeout(() => t.remove(), 250); }, 3500);
    announce(msg, kind === 'error');
  }
  window.HVToast = toast;

  // ── Mega menu (desktop hover) ─────────────────────────────────────────────
  const navLinks = document.querySelectorAll('[data-mega-trigger]');
  const megaPanels = document.querySelectorAll('[data-mega-panel]');
  let megaTimer;
  function openMega(key) {
    clearTimeout(megaTimer);
    navLinks.forEach(l => l.setAttribute('aria-expanded', l.dataset.megaTrigger === key ? 'true' : 'false'));
    megaPanels.forEach(p => p.setAttribute('aria-hidden', p.dataset.megaPanel === key ? 'false' : 'true'));
  }
  function closeMega() {
    megaTimer = setTimeout(() => {
      navLinks.forEach(l => l.setAttribute('aria-expanded', 'false'));
      megaPanels.forEach(p => p.setAttribute('aria-hidden', 'true'));
    }, 80);
  }
  navLinks.forEach(l => {
    l.addEventListener('focus', () => openMega(l.dataset.megaTrigger));
  });
  // Keyboard: the mega opens on focus, so it must also close when focus leaves the nav —
  // otherwise tabbing past the nav leaves the panel hanging open over the page.
  const megaNav = navLinks[0] && navLinks[0].closest('nav, [data-mega-nav], header');
  if (megaNav) {
    megaNav.addEventListener('focusout', (e) => {
      if (!megaNav.contains(e.relatedTarget)) closeMega();
    });
  }
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeMega(); });
  // Hover on the whole <li> so the text link also triggers the mega
  document.querySelectorAll('[data-mega-item]').forEach(item => {
    item.addEventListener('mouseenter', () => openMega(item.dataset.megaItem));
    item.addEventListener('mouseleave', closeMega);
  });
  megaPanels.forEach(p => {
    p.addEventListener('mouseenter', () => openMega(p.dataset.megaPanel));
    p.addEventListener('mouseleave', closeMega);
  });

  // ── Mobile drawer ─────────────────────────────────────────────────────────
  const mobileDrawer = document.querySelector('[data-mobile-drawer]');
  const mobileOverlay = document.querySelector('[data-mobile-overlay]');
  let releaseMobileTrap;
  function openMobile()  { if (!mobileDrawer) return; mobileDrawer.setAttribute('aria-hidden', 'false');
    mobileOverlay && mobileOverlay.setAttribute('aria-hidden', 'false'); document.body.classList.add('hv-locked');
    releaseMobileTrap = trapFocus(mobileDrawer); }
  function closeMobile() { if (!mobileDrawer) return; mobileDrawer.setAttribute('aria-hidden', 'true');
    mobileOverlay && mobileOverlay.setAttribute('aria-hidden', 'true'); document.body.classList.remove('hv-locked');
    if (releaseMobileTrap) releaseMobileTrap(); releaseMobileTrap = null; }
  document.querySelectorAll('[data-mobile-open]').forEach(b => b.addEventListener('click', openMobile));
  document.querySelectorAll('[data-mobile-close]').forEach(b => b.addEventListener('click', closeMobile));
  mobileOverlay && mobileOverlay.addEventListener('click', closeMobile);

  // ── Heevis AI search API ──────────────────────────────────────────────────
  // When window.HV_SEARCH_API is set (see header snippet), predictive search uses our
  // Atlas-backed API and returns results in the same shape the renderers expect. Falls
  // back to Shopify's /search/suggest.json on any error.
  // Robust money formatter — accepts a number, a raw string ("3.38"), Shopify cents (338),
  // or an already-formatted string ("€3,38"); always outputs "€3,38".
  function hvMoney(v) {
    if (v == null || v === '') return '';
    if (typeof v === 'string' && /[€$£]/.test(v)) return v.trim();
    let n = typeof v === 'number' ? v : parseFloat(String(v).replace(/[^0-9.,-]/g, '').replace(',', '.'));
    if (isNaN(n)) return '';
    if (Number.isInteger(n) && n >= 1000) n = n / 100; // Shopify cents -> euros
    return '€' + n.toFixed(2).replace('.', ',');
  }
  function hvFmtPrice(v) { return hvMoney(v); }
  // Was calling the bare /api/search endpoint — no filters, no facets, capped results,
  // structurally poorer than /search/page (pagination + category/vendor filters + facets)
  // that the full results page uses. That gap is exactly why the preview looked "limited"
  // next to what pressing Enter gets you. Same endpoint now, small pageSize, category
  // passthrough so the preview's filter chips (see hvRenderSearchPreview) actually filter.
  async function hvApiSuggest(q, limit, category, vendor) {
    const api = window.HV_SEARCH_API;
    if (!api || window.HV_AI_SEARCH === false) return null; // AI-zoek uit -> Shopify native
    try {
      const pageApi = api.replace(/\/api\/search.*$/, '/api/search/page');
      let url = pageApi + '?q=' + encodeURIComponent(q) + '&pageSize=' + (limit || 8) + '&source=storefront';
      if (category) url += '&category=' + encodeURIComponent(category);
      if (vendor) url += '&vendor=' + encodeURIComponent(vendor);
      const res = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!res.ok) return null;
      const data = await res.json();
      if (!data || !Array.isArray(data.results)) return null;
      return {
        // Betaallinks nooit in de zoeksuggesties.
        products: data.results.filter((p) => !hvIsHidden(p)).map((p) => ({
          url: p.handle ? ('/products/' + p.handle) : (p.url || '#'),
          image: p.image || '',
          title: p.title || '',
          vendor: p.vendor || '',
          price: hvFmtPrice(p.price),
          totalInventory: p.totalInventory,
          stock: p.stock,
        })),
        total: data.total || 0,
        categories: (data.facets && data.facets.categories) || [],
        vendors: (data.facets && data.facets.vendors) || [],
        activeCategory: category || '',
        activeVendor: vendor || '',
      };
    } catch (e) { return null; }
  }
  // Stuurt een klik op een zoekresultaat naar de backend, met de zoekopdracht erbij. De backend
  // koppelt die aan het product en gebruikt het om bij dezelfde zoekopdracht dat product iets
  // hoger te zetten. We sturen de handle mee in plaats van een id: de handle zit altijd in de
  // link, een id zit niet in elke kaart.
  // Deze functie bestond al, maar werd nergens aangeroepen — in 30 dagen stond er daardoor
  // geen enkele zoekklik in de data, terwijl er 2.582 zoekopdrachten waren.
  async function hvSearchClick(q, productId, handle) {
    const api = window.HV_SEARCH_API;
    if (!api || window.HV_AI_SEARCH === false || !q) return;
    try {
      await fetch(api.replace(/\/search.*$/, '/search/click'), {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query: q, productId: productId || undefined, handle: handle || undefined, type: 'text', source: 'storefront' }),
        keepalive: true,
      });
    } catch (e) { /* best-effort analytics */ }
  }
  // Eén luisteraar voor alle zoekoppervlakken (zoekvenster, header-zoekbalk, zoekpagina).
  // Die tekenen hun raster met data-hv-search-q="<zoekopdracht>", zie hvRenderSearchPreview
  // en templates/search.liquid.
  document.addEventListener('click', (e) => {
    const link = e.target.closest && e.target.closest('a[href*="/products/"]');
    if (!link) return;
    const surface = link.closest('[data-hv-search-q]');
    if (!surface) return;
    const m = /\/products\/([^/?#]+)/.exec(link.getAttribute('href') || '');
    if (m) hvSearchClick(surface.getAttribute('data-hv-search-q'), null, decodeURIComponent(m[1]));
  });

  // ── Recommendation-surface click tracking ───────────────────────────────────
  // The /ai-recommendations admin dashboard's "clicks"/CTR KPI reads type:'click:recommendation'
  // events, but nothing ever posted them — every recommendation carousel (PDP alternatives,
  // PDP cross-sell/bought-together, popular, cart upsells) only fetched+rendered, so CTR sat
  // at 0% no matter how much real engagement happened. One delegated listener covers every
  // surface via a shared data-hv-rec-surface marker on each container, rather than wiring
  // click handlers into each carousel's own render code individually.
  document.addEventListener('click', (e) => {
    const api = window.HV_SEARCH_API;
    if (!api || window.HV_AI_RECS === false) return;
    const link = e.target.closest('a');
    if (!link) return;
    const container = link.closest('[data-hv-rec-surface], [data-drops-grid][data-drops-source="popular"]');
    if (!container) return;
    const surface = container.getAttribute('data-hv-rec-surface') || 'popular';
    // Zonder productnummer telde deze klik nergens mee: de backend telt per product, en de 318
    // klikken van de afgelopen maand hadden er geen. Impressies wel — waardoor elk vaak
    // getoond product een CTR van nul kreeg en gestraft werd. De handle zit altijd in de link.
    const hm = /\/products\/([^/?#]+)/.exec(link.getAttribute('href') || '');
    fetch(api.replace(/\/api\/search.*$/, '/api/search/click'), {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ type: 'recommendation', source: 'storefront', surface, handle: hm ? decodeURIComponent(hm[1]) : undefined }),
      keepalive: true,
    }).catch(() => { /* best-effort analytics */ });
  });

  // Eenmalige betaallinks mogen nooit in een aanbeveling of zoekresultaat opduiken. In Liquid
  // filtert de tag hide-from-listings ze weg, maar de aanbevelings- en zoek-API's geven geen
  // tags terug, dus daar herkennen we ze aan de naam. Beide lagen zijn nodig: de tag dekt wat
  // het thema zelf rendert, het patroon dekt wat er van een API binnenkomt.
  const HV_HIDDEN_TITLE = /^\s*(betaallink|betaal link|aanbetaling|bijbetaling|restbetaling)\b/i;
  function hvIsHidden(p) {
    if (!p) return false;
    const tags = p.tags || p.product_tags || [];
    if (Array.isArray(tags) && tags.some(t => String(t).toLowerCase() === 'hide-from-listings')) return true;
    return HV_HIDDEN_TITLE.test(String(p.title || ''));
  }

  window.hvIsHidden = hvIsHidden;
  // Shared card markup for the predictive dropdowns — same .hv-card / grid pattern the full
  // /search results page uses (see templates/search.liquid's card()), not the old cramped
  // single-column list-row style, which looked "boxed"/wasted the dropdown's width badly
  // once the preview grew wide enough to show filter chips above it.
  // Voorraadstand op een zoekkaart, dezelfde drie standen en teksten als de productpagina. De
  // backend stuurt `stock` mee (lib/stockState.js); ontbreekt die, dan de oude benadering op de
  // Shopify-telling. Voorheen stond hier alleen "Leverbaar op bestelling" bij voorraad 0 en
  // niets bij voorraad, dus je zag in de zoekresultaten niet wat je direct kon krijgen.
  function hvStockBadge(p) {
    const state = p.stock || ((p.totalInventory != null && p.totalInventory <= 0) ? 'backorder' : (p.totalInventory > 0 ? 'in_stock' : ''));
    const map = { in_stock: ['in', 'Op voorraad'], backorder: ['backorder', 'Leverbaar 2–5 werkdagen'], supplier_out: ['out', 'Tijdelijk niet leverbaar'] };
    const m = map[state]; if (!m) return '';
    return `<div class="hv-product-card__stock hv-product-card__stock--${m[0]}" style="margin-top:6px;font-size:11.5px"><span class="hv-product-card__stock-dot" aria-hidden="true"></span>${m[1]}</div>`;
  }
  window.hvStockBadge = hvStockBadge;
  function hvSearchCard(p) {
    if (hvIsHidden(p)) return '';
    const img = p.image
      ? `<img src="${p.image}" alt="" loading="lazy" style="width:100%;aspect-ratio:1;object-fit:contain;background:#fff">`
      : `<div class="hv-noimg" style="aspect-ratio:1;height:auto" role="img" aria-label="Foto volgt"></div>`;
    const price = hvMoney(p.price);
    const stock = hvStockBadge(p);
    return `<a href="${p.url}" class="hv-card" style="text-decoration:none;color:inherit;display:block">${img}
        <div style="padding:12px 12px 14px">
          <div style="font-weight:600;font-size:13.5px;line-height:1.35;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical">${escapeHtml(p.title)}</div>
          <div class="hv-text-dim" style="font-size:11.5px;margin-top:3px">${p.vendor ? escapeHtml(p.vendor) : ''}</div>
          ${price ? `<div data-hv-price style="font-weight:700;margin-top:6px;font-size:13px">${price}</div>` : ''}
          ${stock}
        </div></a>`;
  }

  // Shared by the overlay AND the inline header search — those used to be two separate,
  // slightly-inconsistent implementations (different result counts, thumb sizes, and
  // neither had any filtering at all despite the backend's /search/page already computing
  // category + vendor facets for the full results page). One render function, one set of
  // filter chips, same result count everywhere.
  function hvSearchChips(options, active, field, label) {
    if (!options || !options.length) return '';
    const all = `<button type="button" class="hv-search-chip${active ? '' : ' is-active'}" data-search-chip="${field}" data-search-chip-value="">Alles</button>`;
    const chips = options.slice(0, 6).map((c) => `<button type="button" class="hv-search-chip${c.slug === active || c.value === active ? ' is-active' : ''}" data-search-chip="${field}" data-search-chip-value="${escapeHtml(c.slug || c.value)}">${escapeHtml(c.label || c.value)} <span class="hv-search-chip__count">${c.count}</span></button>`).join('');
    return `<div class="hv-search-overlay__chips" role="group" aria-label="Filter op ${label}">${all}${chips}</div>`;
  }
  function hvRenderSearchPreview(container, r, q, opts) {
    opts = opts || {};
    if (!r) return;
    const chips = hvSearchChips(r.categories, r.activeCategory, 'category', 'categorie') +
      (r.vendors && r.vendors.length > 1 ? hvSearchChips(r.vendors, r.activeVendor, 'vendor', 'merk') : '');
    const sections = [];
    if (r.products && r.products.length) sections.push(`
      <div class="hv-search-overlay__section">
        <div class="hv-mono hv-mb-2">PRODUCTEN${r.total ? ` · ${r.total}` : ''}</div>
        <div class="hv-drops__grid hv-search-preview__grid" data-hv-search-q="${escapeHtml(q || '')}">${r.products.map(hvSearchCard).join('')}</div>
      </div>`);
    if (r.articles && r.articles.length) sections.push(`
      <div class="hv-search-overlay__section">
        <div class="hv-mono hv-mb-2">GIDSEN</div>
        ${r.articles.map(a => `
          <a href="${a.url}" class="hv-search-overlay__hit">
            <div style="width:48px;height:48px;background:var(--hv-panel);border-radius:6px;display:flex;align-items:center;justify-content:center">📖</div>
            <div style="flex:1"><div style="font-weight:600">${escapeHtml(a.title)}</div></div>
          </a>`).join('')}
      </div>`);
    if (r.pages && r.pages.length) sections.push(`
      <div class="hv-search-overlay__section">
        <div class="hv-mono hv-mb-2">PAGINA'S</div>
        ${r.pages.map(p => `<a href="${p.url}" class="hv-search-overlay__hit"><div style="flex:1"><div style="font-weight:600">${escapeHtml(p.title)}</div></div></a>`).join('')}
      </div>`);
    const activeFilters = (r.activeCategory ? '&category=' + encodeURIComponent(r.activeCategory) : '') +
      (r.activeVendor ? '&vendor=' + encodeURIComponent(r.activeVendor) : '');
    if (!sections.length) {
      const hasFilter = r.activeCategory || r.activeVendor;
      container.innerHTML = chips + `<div class="hv-search-overlay__hint hv-text-mute">Geen resultaten voor "${escapeHtml(q)}"${hasFilter ? ' met dit filter' : ''}. Probeer een ander woord${hasFilter ? ' of kies "Alles"' : ''}.</div>`;
    } else {
      const allHref = `/search?q=${encodeURIComponent(q)}${activeFilters}`;
      const allLabel = r.total ? `Alle ${r.total} resultaten voor "${escapeHtml(q)}"` : `Alle resultaten voor "${escapeHtml(q)}"`;
      container.innerHTML = chips + sections.join('') +
        `<div style="text-align:center;padding-top:16px;border-top:.5px solid var(--hv-line);margin-top:16px">
           <a class="hv-btn hv-btn--ghost hv-btn--sm" href="${allHref}">${allLabel}</a>
         </div>`;
    }
    if (opts.onFilterChange) {
      container.querySelectorAll('[data-search-chip]').forEach((btn) => {
        btn.addEventListener('click', () => opts.onFilterChange(btn.getAttribute('data-search-chip'), btn.getAttribute('data-search-chip-value') || ''));
      });
    }
  }

  // ── Search overlay ────────────────────────────────────────────────────────
  const searchOverlay = document.querySelector('[data-search-overlay]');
  const searchInput   = document.querySelector('[data-search-input]');
  const searchResults = document.querySelector('[data-search-results]');
  let releaseSearchTrap;
  function openSearch()  { if (!searchOverlay) return; searchOverlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('hv-locked');
    setTimeout(() => searchInput && searchInput.focus(), 50);
    releaseSearchTrap = trapFocus(searchOverlay); }
  function closeSearch() { if (!searchOverlay) return; searchOverlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('hv-locked');
    if (releaseSearchTrap) releaseSearchTrap(); releaseSearchTrap = null; }
  document.querySelectorAll('[data-search-open]').forEach(b =>
    b.addEventListener('click', (e) => { e.preventDefault(); openSearch(); }));
  document.querySelectorAll('[data-search-close]').forEach(b => b.addEventListener('click', closeSearch));
  searchOverlay && searchOverlay.addEventListener('click', (e) => {
    if (e.target === searchOverlay) closeSearch();
  });

  if (searchInput) {
    let overlayCategory = '', overlayVendor = '';
    const fetchSearch = debounce(async (q) => {
      if (!q || q.length < 2) { searchResults.innerHTML = '<div class="hv-search-overlay__hint hv-text-mute">Begin met typen — minimaal 2 letters.</div>'; return; }
      try {
        // Our AI-backed API first; fall back to Shopify's native suggest on failure.
        const mine = await hvApiSuggest(q, 8, overlayCategory, overlayVendor);
        if (mine) {
          hvRenderSearchPreview(searchResults, mine, q, {
            onFilterChange: (field, value) => {
              if (field === 'vendor') overlayVendor = value; else overlayCategory = value;
              fetchSearch(searchInput.value);
            },
          });
          return;
        }
        const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,article,page&resources[limit]=8`,
          { headers: { Accept: 'application/json' } });
        const data = await res.json();
        hvRenderSearchPreview(searchResults, data.resources.results, q, {});
      } catch (err) { console.warn(err); }
    }, 180);
    searchInput.addEventListener('input', (e) => { overlayCategory = ''; overlayVendor = ''; fetchSearch(e.target.value); });
  }

  // ── Inline header search (predictive, dropdown panel) ─────────────────────
  (function initInlineSearch(){
    const form = document.querySelector('[data-inline-search]');
    if (!form) return;
    const input   = form.querySelector('[data-inline-search-input]');
    const panel   = form.querySelector('[data-inline-search-panel]');
    const results = form.querySelector('[data-inline-search-results]');
    const clearBtn = form.querySelector('[data-inline-search-clear]');
    const HINT_EMPTY = '<div class="hv-search-inline__hint hv-text-mute">Begin met typen — minimaal 2 letters.</div>';

    function openPanel()  {
      panel.setAttribute('aria-hidden', 'false');
      // Full-screen takeover on desktop: pin the panel below the search bar, dim the page.
      if (window.matchMedia('(min-width: 1024px)').matches) {
        const r = form.getBoundingClientRect();
        panel.style.position = 'fixed';
        panel.style.top = (r.bottom + 8) + 'px';
        panel.style.left = '0';
        panel.style.right = '0';
        document.body.classList.add('hv-search-fs');
      }
    }
    function closePanel() {
      panel.setAttribute('aria-hidden', 'true');
      panel.style.position = ''; panel.style.top = ''; panel.style.left = ''; panel.style.right = '';
      document.body.classList.remove('hv-search-fs');
    }

    input.addEventListener('focus', openPanel);
    input.addEventListener('click', openPanel);
    document.addEventListener('click', (e) => {
      if (!form.contains(e.target)) closePanel();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && panel.getAttribute('aria-hidden') === 'false') {
        closePanel(); input.blur();
      }
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        input.focus(); input.select(); openPanel();
      }
    });

    // Was its own near-duplicate of the overlay's renderer (6 results instead of 8, smaller
    // thumb, no filters) — now the same shared hvRenderSearchPreview, same result count,
    // same category chips, so the two search entry points behave identically.
    let inlineCategory = '', inlineVendor = '';
    const fetchInline = debounce(async (q) => {
      if (!q || q.length < 2) { results.innerHTML = HINT_EMPTY; return; }
      try {
        const mine = await hvApiSuggest(q, 8, inlineCategory, inlineVendor);
        if (mine) {
          hvRenderSearchPreview(results, mine, q, {
            onFilterChange: (field, value) => {
              if (field === 'vendor') inlineVendor = value; else inlineCategory = value;
              fetchInline(input.value);
            },
          });
          return;
        }
        const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,article,page&resources[limit]=8`,
          { headers: { Accept: 'application/json' } });
        const data = await res.json();
        hvRenderSearchPreview(results, data.resources.results, q, {});
      } catch (err) { console.warn(err); }
    }, 180);

    input.addEventListener('input', (e) => {
      const v = e.target.value;
      if (clearBtn) clearBtn.hidden = !v;
      openPanel();
      inlineCategory = ''; inlineVendor = '';
      fetchInline(v);
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        input.value = '';
        clearBtn.hidden = true;
        inlineCategory = ''; inlineVendor = '';
        results.innerHTML = HINT_EMPTY;
        input.focus();
      });
    }
  })();

  // ── Inline search: category dropdown (prefix) ─────────────────────────────
  (function initCategoryDropdown(){
    const wrap = document.querySelector('[data-cat-dropdown]');
    if (!wrap) return;
    const trigger = wrap.querySelector('[data-cat-trigger]');
    const menu    = wrap.querySelector('[data-cat-menu]');
    const label   = wrap.querySelector('[data-cat-label]');
    const input   = wrap.querySelector('[data-cat-input]');
    const opts    = wrap.querySelectorAll('[data-cat-option]');

    function open()  { menu.hidden = false; trigger.setAttribute('aria-expanded', 'true'); }
    function close() { menu.hidden = true;  trigger.setAttribute('aria-expanded', 'false'); }

    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      menu.hidden ? open() : close();
    });
    document.addEventListener('click', (e) => {
      if (!wrap.contains(e.target)) close();
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

    opts.forEach(opt => {
      opt.addEventListener('click', () => {
        const val = opt.getAttribute('value') || '';
        const txt = opt.textContent.trim();
        if (input) input.value = val;
        if (label) label.textContent = txt;
        opts.forEach(o => o.removeAttribute('aria-selected'));
        opt.setAttribute('aria-selected', 'true');
        close();
      });
    });
  })();

  // ── Announcement bar carousel ─────────────────────────────────────────────
  (function initAnnouncement(){
    const bar = document.querySelector('[data-announcement]');
    if (!bar) return;
    const slides = bar.querySelectorAll('[data-announcement-slide]');
    if (slides.length <= 1) return;
    let idx = 0;
    function show(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach((s, k) => s.setAttribute('aria-hidden', k === idx ? 'false' : 'true'));
    }
    const prev = bar.querySelector('[data-announcement-prev]');
    const next = bar.querySelector('[data-announcement-next]');
    prev && prev.addEventListener('click', () => { show(idx - 1); restart(); });
    next && next.addEventListener('click', () => { show(idx + 1); restart(); });

    const interval = parseInt(getComputedStyle(bar).getPropertyValue('--hv-announcement-interval')) || 6000;
    let timer;
    function start() { if (interval > 0) timer = setInterval(() => show(idx + 1), interval); }
    function stop()  { clearInterval(timer); }
    function restart() { stop(); start(); }
    start();
    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
  })();

  // ── Cart drawer ───────────────────────────────────────────────────────────
  const drawer  = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-overlay]');
  let releaseCartTrap;
  function openCart()  { if (!drawer) return; drawer.setAttribute('aria-hidden', 'false');
    overlay && overlay.setAttribute('aria-hidden', 'false'); document.body.classList.add('hv-locked');
    refreshCart();
    setTimeout(() => { releaseCartTrap = trapFocus(drawer); }, 100); }
  function closeCart() { if (!drawer) return; drawer.setAttribute('aria-hidden', 'true');
    overlay && overlay.setAttribute('aria-hidden', 'true'); document.body.classList.remove('hv-locked');
    if (releaseCartTrap) releaseCartTrap(); releaseCartTrap = null; }
  document.querySelectorAll('[data-cart-open]').forEach(b => b.addEventListener('click', (e) => {
    e.preventDefault(); openCart(); }));
  document.querySelectorAll('[data-cart-close]').forEach(b => b.addEventListener('click', closeCart));
  overlay && overlay.addEventListener('click', closeCart);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { closeCart(); closeMobile(); closeSearch(); }
  });

  async function refreshCart() {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      // Shopify's /cart.js doesn't include product tags on items — enrich them
      // for the free-shipping exclusion logic. Tags are cached per session.
      await enrichItemTags(cart.items);
      renderCart(cart);
    } catch (err) { console.warn('Cart fetch failed', err); }
  }
  const __tagCache = {};
  async function enrichItemTags(items) {
    const need = items.filter(i => !i.product_tags && !__tagCache[i.handle]);
    await Promise.all(need.map(i =>
      fetch(`/products/${i.handle}.js`, { headers: { Accept: 'application/json' } })
        .then(r => r.ok ? r.json() : null)
        .then(p => { if (p) __tagCache[i.handle] = p.tags || []; })
        .catch(() => {})
    ));
    items.forEach(i => { i.product_tags = i.product_tags || __tagCache[i.handle] || []; });
  }
  function renderCart(cart) {
    const itemsEl = drawer && drawer.querySelector('[data-cart-items]');
    const totalEl = drawer && drawer.querySelector('[data-cart-total]');
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count; el.hidden = cart.item_count === 0;
    });
    if (!itemsEl) return;
    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<p class="hv-text-dim" style="padding:24px 0">Je winkelwagen is leeg.</p>';
    } else {
      itemsEl.innerHTML = cart.items.map(it => `
        <div class="hv-cart-drawer__item">
          ${it.image ? `<img src="${it.image}" alt="${escapeHtml(it.title)}" style="width:64px;height:64px;object-fit:cover;border-radius:6px">`
            : `<div class="hv-noimg hv-noimg--sm" style="width:64px;height:64px;flex-shrink:0" role="img" aria-label="Foto volgt"></div>`}
          <div>
            <div style="font-weight:600;font-size:14px">${escapeHtml(it.product_title)}</div>
            ${it.variant_title && it.variant_title !== 'Default Title' ? `<div class="hv-text-dim" style="font-size:12.5px;margin-top:2px">${escapeHtml(it.variant_title)}</div>` : ''}
            <div style="margin-top:8px;display:flex;align-items:center;gap:6px">
              <button class="hv-qty-btn" data-cart-qty="-" data-key="${it.key}">−</button>
              <span style="font-variant-numeric:tabular-nums;min-width:18px;text-align:center">${it.quantity}</span>
              <button class="hv-qty-btn" data-cart-qty="+" data-key="${it.key}">+</button>
            </div>
          </div>
          <div style="text-align:right">
            <div style="font-weight:600">${formatMoney(it.final_line_price)}</div>
            <button class="hv-text-mute" data-cart-remove data-key="${it.key}"
                    style="background:transparent;border:0;font-size:11.5px;text-decoration:underline;margin-top:4px;cursor:pointer">
              Verwijderen</button>
          </div>
        </div>
      `).join('');
      itemsEl.querySelectorAll('[data-cart-qty]').forEach(btn => {
        btn.addEventListener('click', () => changeQty(btn.dataset.key,
          btn.dataset.cartQty === '+' ? 1 : -1));
      });
      itemsEl.querySelectorAll('[data-cart-remove]').forEach(btn => {
        btn.addEventListener('click', () => changeQty(btn.dataset.key, 'remove'));
      });
    }
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    // Live-arrival-notitie alleen als er ook echt een dier in de winkelwagen zit.
    const liveNote = drawer && drawer.querySelector('[data-cart-live-note]');
    if (liveNote) {
      const heeftDier = (cart.items || []).some(i => (i.product_tags || __tagCache[i.handle] || []).includes('live-stock'));
      liveNote.hidden = !heeftDier;
    }
    // Free shipping progress (with tag exclusion for live animals)
    renderShippingBar(cart);
    // Upsells — fire-and-forget: never let a failed recommendations fetch (e.g. a
    // blocked cross-origin request) affect the cart drawer, which is already visible
    // by the time this runs.
    populateUpsells(cart).catch(() => {});
    // Notes/discount sync
    syncCartExtras(cart);
  }

  function eligibleForFreeShipping(items) {
    const excludeTags = window.HV_FREE_SHIP_EXCLUDE_TAGS || [];
    let eligibleTotal = 0; let hasExcluded = false;
    items.forEach(it => {
      const tags = (it.product_tags || []).concat(it.variant_options || []).map(t => String(t).toLowerCase());
      const isExcluded = excludeTags.some(et => tags.includes(et.toLowerCase()));
      if (isExcluded) hasExcluded = true;
      else eligibleTotal += it.final_line_price;
    });
    return { eligibleTotal, hasExcluded };
  }
  function renderShippingBar(cart) {
    const bar = drawer && drawer.querySelector('[data-ship-bar]');
    if (!bar) return;
    if (cart.item_count === 0) { bar.hidden = true; return; }
    bar.hidden = false;
    const threshold = window.HV_FREE_SHIP_THRESHOLD || 7500;
    const { eligibleTotal, hasExcluded } = eligibleForFreeShipping(cart.items);
    const remaining = Math.max(0, threshold - eligibleTotal);
    const pct = Math.min(100, (eligibleTotal / threshold) * 100);
    const msg = bar.querySelector('[data-ship-msg]');
    const fill = bar.querySelector('[data-ship-fill]');
    bar.classList.toggle('hv-ship-bar--done', remaining === 0);
    bar.classList.toggle('hv-ship-bar--excluded', hasExcluded && remaining === 0);
    fill.style.width = pct + '%';
    if (remaining === 0 && !hasExcluded) {
      msg.innerHTML = '✓ <strong>Gratis verzending</strong> geactiveerd.';
    } else if (remaining === 0 && hasExcluded) {
      msg.innerHTML = '✓ <strong>Gratis verzending</strong> · live dieren altijd betaald (€18.50)';
    } else if (hasExcluded) {
      msg.innerHTML = `Nog <strong>${formatMoney(remaining)}</strong> voor gratis verzending op niet-live items. <em>(Live dieren altijd €18.50 ivm heatpack)</em>`;
    } else {
      msg.innerHTML = `Nog <strong>${formatMoney(remaining)}</strong> voor gratis verzending.`;
    }
  }

  function syncCartExtras(cart) {
    const note = drawer && drawer.querySelector('[data-cart-note]');
    if (note && document.activeElement !== note) note.value = cart.note || '';
  }
  async function changeQty(key, op) {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    const cart = await res.json();
    const item = cart.items.find(i => i.key === key);
    if (!item) return;
    let qty = item.quantity;
    if (op === 1 || op === '+') qty++; else if (op === -1 || op === '-') qty--; else qty = 0;
    await fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) }),
    });
    refreshCart();
  }

  async function populateUpsells(cart) {
    const railEl = drawer && drawer.querySelector('[data-cart-upsells]');
    if (!railEl || cart.item_count === 0) { if (railEl) railEl.innerHTML = ''; return; }
    const productId = cart.items[0].product_id;
    let items = null;

    // Prefer our "vaak samen gekocht" API (real order co-occurrence). Single-variant only,
    // so a "+" can add straight to cart. Falls back to Shopify's native related products.
    const api = window.HV_SEARCH_API;
    if (api && window.HV_AI_RECS !== false) {
      try {
        const base = api.replace(/\/api\/search.*$/, '/api/recommendations/bought-together');
        const res = await fetch(`${base}?product_id=${productId}&limit=4&source=storefront`, { headers: { Accept: 'application/json' } });
        if (res.ok) {
          const d = await res.json();
          if (d && Array.isArray(d.results) && d.results.length) {
            items = d.results
              .filter(p => p.variantsCount === 1 && p.variantId && !hvIsHidden(p))
              .slice(0, 3)
              .map(p => ({ url: p.handle ? '/products/' + p.handle : (p.url || '#'), image: p.image || '', title: p.title || '', priceStr: (p.price == null ? '' : '€' + Number(p.price).toFixed(2).replace('.', ',')), variantId: p.variantId }));
          }
        }
      } catch (e) { /* fall through */ }
    }
    // Geen terugval op Shopify's eigen "related": die weet niets van zoet/zee/terrarium en zette
    // zeewaterproducten bij een zoetwaterbak (okt 2026). Geen echte "vaak samen gekocht" -> niets tonen.
    if (!items || !items.length) { railEl.innerHTML = ''; return; }

    railEl.innerHTML = `
      <div class="hv-mono" style="margin-bottom:6px;font-size:10px">VAAK SAMEN GEKOCHT</div>
      <div class="hv-cart-drawer__upsells">
        ${items.slice(0, 2).map(p => `
          <a href="${p.url}" class="hv-cart-drawer__upsell">
            ${p.image ? `<img src="${p.image}" alt="${escapeHtml(p.title)}" style="width:36px;height:36px;object-fit:cover;border-radius:4px">`
              : '<div class="hv-noimg hv-noimg--sm" style="width:36px;height:36px;flex-shrink:0" role="img" aria-label="Foto volgt"></div>'}
            <div style="flex:1;min-width:0">
              <div style="font-weight:500;font-size:12.5px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">${escapeHtml(p.title)}</div>
              <div class="hv-text-dim" style="font-size:11px"><span data-hv-price>${p.priceStr}</span></div>
            </div>
            <button class="hv-btn hv-btn--sm" data-upsell-add data-variant-id="${p.variantId}">+</button>
          </a>`).join('')}
      </div>
    `;
    railEl.querySelectorAll('[data-upsell-add]').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const id = btn.dataset.variantId; if (!id) return;
        // Tag as recommendation-sourced so the order attributes revenue to recommendations.
        await fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id, quantity: 1, properties: { _hv_source: 'recommendation' } }),
        });
        refreshCart();
      });
    });
  }

  // ── Add-to-cart forms ─────────────────────────────────────────────────────
  document.querySelectorAll('form[action$="/cart/add"]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const submitBtn = form.querySelector('button[type="submit"]');
      const labelEl = submitBtn ? submitBtn.querySelector('[data-pdp-submit-label]') || submitBtn : null;
      const orig = labelEl ? labelEl.textContent : '';
      if (submitBtn) { submitBtn.disabled = true; if (labelEl) labelEl.textContent = 'Toevoegen…'; }
      try {
        const fd = new FormData(form);
        const res = await fetch('/cart/add.js', { method: 'POST', body: fd,
          headers: { Accept: 'application/json' } });
        if (!res.ok) {
          const err = await res.json();
          toast(err.description || 'Toevoegen mislukt', 'error');
          if (labelEl) labelEl.textContent = err.description || 'Toevoegen mislukt';
          setTimeout(() => { if (labelEl) labelEl.textContent = orig; }, 2000);
          return;
        }
        const added = await res.json();
        toast(`${added.product_title || 'Product'} toegevoegd aan winkelwagen`);
        openCart();
      } catch (err) { console.warn(err); toast('Geen verbinding', 'error'); }
      finally {
        if (submitBtn) submitBtn.disabled = false;
        if (labelEl && labelEl.textContent === 'Toevoegen…') labelEl.textContent = orig;
      }
    });
  });

  // ── Cart notes + discount field ──────────────────────────────────────────
  const noteEl = drawer && drawer.querySelector('[data-cart-note]');
  if (noteEl) {
    const saveNote = debounce(async (v) => {
      await fetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: v }),
      });
      announce('Notitie opgeslagen');
    }, 500);
    noteEl.addEventListener('input', (e) => saveNote(e.target.value));
  }
  const discountForm = drawer && drawer.querySelector('[data-discount-form]');
  if (discountForm) {
    discountForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const code = discountForm.querySelector('input[name="discount"]').value.trim();
      if (!code) return;
      // Shopify applies discount via checkout — we redirect to /discount/CODE which redirects back to /cart
      window.location.href = `/discount/${encodeURIComponent(code)}?redirect=/cart`;
    });
  }

  window.HVCart = { open: openCart, close: closeCart, refresh: refreshCart };

  // ── Accordion ─────────────────────────────────────────────────────────────
  document.querySelectorAll('[data-acc-btn]').forEach(btn => {
    const item = btn.closest('[data-acc-item]');
    // Mirror the initial visual state into ARIA so screen readers start in sync.
    if (item) btn.setAttribute('aria-expanded', item.dataset.open === 'true' ? 'true' : 'false');
    btn.addEventListener('click', () => {
      if (!item) return;
      const open = item.dataset.open === 'true';
      item.dataset.open = open ? 'false' : 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  });

  // ── PDP variant picker (live price / availability / submit label) ────────
  document.querySelectorAll('[data-product-info]').forEach(scope => {
    const jsonEl  = scope.querySelector('[data-product-json]');
    const optionBtns = scope.querySelectorAll('[data-pdp-opt]');
    const hiddenId   = scope.querySelector('input[name="id"]');
    const priceEl    = scope.querySelector('[data-pdp-price]');
    const compareEl  = scope.querySelector('[data-pdp-compare]');
    const stockEl    = scope.querySelector('[data-pdp-stock]');
    const stockText  = scope.querySelector('[data-pdp-stock-text]');
    const submitBtn  = scope.querySelector('[data-pdp-submit]');
    const submitLab  = scope.querySelector('[data-pdp-submit-label]');
    const urgencyEl  = scope.querySelector('[data-pdp-inventory]');
    if (!jsonEl) return;
    let variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    if (!Array.isArray(variants) || variants.length === 0) return;

    // ── Per-location inventory (optional; configured via section settings) ────────
    let invCfg = null;
    try { const c = scope.querySelector('[data-hv-inventory-config]'); if (c) invCfg = JSON.parse(c.textContent); } catch (e) {}
    const invEnabled = !!(invCfg && invCfg.apiUrl);
    const productId  = scope.getAttribute('data-product-id');
    let invData = null;                 // { variants: { <id>: {state,purchasable,tracked,primaryQty,otherQty} } }
    let invState = invEnabled ? 'loading' : 'off'; // off | loading | ready | error

    const CLR_OK = 'var(--hv-accent)';
    const CLR_BAD = 'var(--hv-danger)';
    const CLR_WARN = 'var(--hv-warning, #c47f00)';
    const CLR_MUTE = 'var(--hv-text-mute, #8a8f98)';

    function paintBadge(color, text) {
      if (!stockEl || !stockText) return;
      stockEl.style.background = 'color-mix(in srgb, ' + color + ' 14%, transparent)';
      stockEl.style.color = color;
      if (stockEl.firstElementChild) stockEl.firstElementChild.style.background = color;
      stockText.textContent = text;
    }
    // Actieprijs: alleen als Liquid deze productpagina als actieproduct heeft getekend.
    const promoPct = priceEl ? parseFloat(priceEl.dataset.promoPct || '0') : 0;
    function pdpPrice(v) { return (promoPct > 0 && hvPromoOn()) ? hvPromoCents(v.price, promoPct) : v.price; }
    function setSubmit(v, purchasable, soldLabel) {
      if (!submitBtn || !submitLab) return;
      submitBtn.disabled = !purchasable;
      submitLab.textContent = purchasable ? ('In winkelmandje · ' + formatMoney(pdpPrice(v))) : (soldLabel || 'Uitverkocht');
    }
    function txt(k, d) { return (invCfg && invCfg.texts && invCfg.texts[k]) || d; }

    // Decide the badge + button for a variant. Uses per-location data when ready;
    // otherwise falls back to Shopify's total `available` flag so the status is never blank/wrong.
    function applyAvailability(v) {
      // While the per-location call is in flight: neutral message, no misleading status.
      if (invState === 'loading') {
        paintBadge(CLR_MUTE, txt('loading', 'Voorraad controleren…'));
        return;
      }
      const rec = (invState === 'ready' && invData && invData.variants) ? invData.variants[v.id] : null;
      if (rec) {
        if (urgencyEl) urgencyEl.style.display = 'none'; // badge is authoritative now
        if (rec.state === 'in_stock') {
          const low = invCfg.lowThreshold || 0;
          if (rec.tracked && low > 0 && rec.primaryQty > 0 && rec.primaryQty <= low) {
            paintBadge(CLR_WARN, String(txt('low', 'Nog %n% op voorraad')).replace('%n%', rec.primaryQty));
          } else {
            paintBadge(CLR_OK, txt('inStock', 'Op voorraad'));
          }
        } else if (rec.state === 'backorder') {
          paintBadge(CLR_WARN, txt('backorder', 'Leverbaar binnen 2–5 werkdagen'));
        } else {
          paintBadge(CLR_BAD, txt('soldOut', 'Tijdelijk uitverkocht'));
        }
        setSubmit(v, rec.purchasable, txt('soldOut', 'Tijdelijk uitverkocht'));
        return;
      }
      // Fallback: no config, error, or unknown variant -> Shopify total availability.
      // Eigen voorraad 0 maar toch bestelbaar (doorverkopen aan): wij bestellen het, dus een
      // levertijd tonen in plaats van "op voorraad". ownStock komt uit product-main.liquid en
      // ontbreekt bij producten met een leveranciersfeed.
      const own = invCfg && invCfg.ownStock ? invCfg.ownStock[v.id] : null;
      if (v.available && own && own.tracked && own.qty <= 0) { paintBadge(CLR_WARN, txt('backorder', 'Leverbaar binnen 2–5 werkdagen')); }
      else if (v.available) { paintBadge(CLR_OK, txt('inStock', 'Op voorraad')); }
      else { paintBadge(CLR_BAD, 'Uitverkocht — waitlist'); }
      setSubmit(v, v.available, 'Uitverkocht');
    }

    const requiredGroups = Array.from(scope.querySelectorAll('[data-opt-required]'))
      .map(el => el.dataset.optRequired);
    function currentOptions() {
      const sel = {};
      scope.querySelectorAll('[data-pdp-opt][aria-pressed="true"]').forEach(b => {
        sel[b.dataset.optGroup] = b.dataset.optValue;
      });
      return sel;
    }
    function findVariant() {
      const sel = currentOptions();
      const keys = Object.keys(sel);
      return variants.find(v => {
        return keys.every((k, i) => {
          const optName = (v[`option${i + 1}`] || '').toString();
          // option key may be 'size' (handle) vs 'Size' (display) — compare values only
          return optName === sel[k];
        });
      }) || variants.find(v => keys.every((k, i) => {
        const optVal = sel[k];
        const variantVals = [v.option1, v.option2, v.option3].filter(Boolean);
        return variantVals.includes(optVal);
      })) || variants[0];
    }
    function update() {
      const v = findVariant();
      if (!v) return;
      hiddenId.value = v.id;
      if (priceEl && promoPct > 0 && hvPromoOn()) {
        const label = priceEl.dataset.promoLabel || '';
        priceEl.innerHTML = '<span class="hv-pp__new">' + formatMoney(pdpPrice(v)) + '</span>'
          + '<span class="hv-pp__old hv-pdp__was">' + formatMoney(v.price) + '</span>'
          + (label ? '<span class="hv-savings hv-pp__badge" style="margin-left:8px">' + escapeHtml(label) + '</span>' : '');
        priceEl.dataset.priceCents = pdpPrice(v);
      } else if (priceEl) {
        // Preserve the compare-at span by re-rendering current price text node
        const cmp = compareEl ? compareEl.outerHTML : '';
        priceEl.innerHTML = formatMoney(v.price) + (cmp || '');
        priceEl.dataset.priceCents = v.price;
      }
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = formatMoney(v.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      // Stock badge + submit button — per-location aware (with total-availability fallback).
      applyAvailability(v);
      // Opties die een bewuste keuze vragen (afhalen/bezorgen): zolang er niets gekozen is
      // blijft de bestelknop dicht, ongeacht wat applyAvailability hierboven besloot.
      const missing = requiredGroups.filter(g => !currentOptions()[g]);
      if (missing.length && submitBtn && submitLab) {
        submitBtn.disabled = true;
        submitLab.textContent = 'Kies eerst: ' + missing.map(g => g.replace(/-/g, ' / ')).join(' en ');
      }
      // Reflect in URL so deep-links to a variant work
      const url = new URL(window.location);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url);
    }
    optionBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const group = btn.dataset.optGroup;
        scope.querySelectorAll(`[data-opt-group="${group}"]`).forEach(b =>
          b.setAttribute('aria-pressed', 'false'));
        btn.setAttribute('aria-pressed', 'true');
        update();
      });
    });

    // Fetch per-location availability once, then repaint whichever variant is selected.
    if (invEnabled && productId) {
      const sep = invCfg.apiUrl.indexOf('?') === -1 ? '?' : '&';
      const url = invCfg.apiUrl + sep + 'product_id=' + encodeURIComponent(productId);
      fetch(url, { headers: { Accept: 'application/json' } })
        .then(r => (r.ok ? r.json() : Promise.reject(new Error('HTTP ' + r.status))))
        .then(data => { if (data && data.variants) { invData = data; invState = 'ready'; } else { invState = 'error'; } })
        .catch(() => { invState = 'error'; })
        .finally(() => update());
    }

    // Initial paint: shows the loading state (if enabled) or the fallback status.
    update();
  });

  // ── PDP gallery thumb swap + zoom on click ────────────────────────────────
  document.querySelectorAll('[data-pdp-main]').forEach(main => {
    main.addEventListener('click', () => {
      const img = main.querySelector('img');
      if (!img) return;
      openLightbox(img.src, img.alt);
    });
  });
  function openLightbox(src, alt) {
    let lb = document.querySelector('[data-lightbox]');
    if (!lb) {
      lb = document.createElement('div');
      lb.setAttribute('data-lightbox', '');
      lb.className = 'hv-lightbox';
      lb.innerHTML = `<button class="hv-lightbox__close" aria-label="Sluiten">×</button><img alt=""><div class="hv-lightbox__hint hv-mono">Klik om te sluiten</div>`;
      document.body.appendChild(lb);
      lb.addEventListener('click', closeLightbox);
    }
    lb.querySelector('img').src = src;
    lb.querySelector('img').alt = alt || '';
    lb.setAttribute('aria-hidden', 'false');
    document.body.classList.add('hv-locked');
  }
  function closeLightbox() {
    const lb = document.querySelector('[data-lightbox]');
    if (lb) lb.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('hv-locked');
  }

  // ── Before/after slider ───────────────────────────────────────────────────
  document.querySelectorAll('[data-beforeafter]').forEach(el => {
    const after  = el.querySelector('[data-ba-after]');
    const handle = el.querySelector('[data-ba-handle]');
    let dragging = false;
    function setPct(pct) {
      pct = Math.max(0, Math.min(100, pct));
      if (after)  after.style.clipPath = `inset(0 ${100 - pct}% 0 0)`;
      if (handle) handle.style.left = pct + '%';
    }
    el.addEventListener('mousedown',  () => dragging = true);
    el.addEventListener('touchstart', () => dragging = true, { passive: true });
    window.addEventListener('mouseup',  () => dragging = false);
    window.addEventListener('touchend', () => dragging = false);
    function onMove(clientX) {
      if (!dragging) return;
      const r = el.getBoundingClientRect();
      setPct(((clientX - r.left) / r.width) * 100);
    }
    el.addEventListener('mousemove', (e) => onMove(e.clientX));
    el.addEventListener('touchmove', (e) => onMove(e.touches[0].clientX), { passive: true });
    el.addEventListener('click', (e) => {
      const r = el.getBoundingClientRect();
      setPct(((e.clientX - r.left) / r.width) * 100);
    });
    setPct(50);
  });

  // ── Configurator step navigation + live BOM ──────────────────────────────
  const cfg = document.querySelector('[data-configurator]');
  if (cfg) {
    const steps = cfg.querySelectorAll('[data-cfg-step]');
    const panels = cfg.querySelectorAll('[data-cfg-panel]');
    function activate(idx) {
      steps.forEach((s,i)  => s.setAttribute('aria-current',  i === idx ? 'true' : 'false'));
      panels.forEach((p,i) => p.hidden = i !== idx);
    }
    steps.forEach((s, i) => s.addEventListener('click', () => activate(i)));
    cfg.querySelectorAll('[data-cfg-next]').forEach(b => b.addEventListener('click', () => {
      const cur = [...steps].findIndex(s => s.getAttribute('aria-current') === 'true');
      if (cur < steps.length - 1) activate(cur + 1);
    }));
    cfg.querySelectorAll('[data-cfg-prev]').forEach(b => b.addEventListener('click', () => {
      const cur = [...steps].findIndex(s => s.getAttribute('aria-current') === 'true');
      if (cur > 0) activate(cur - 1);
    }));
    activate(0);

    // Live BOM — recalc total + kWh when any radio in the form changes
    const bomTotal = cfg.querySelector('[data-bom-total]');
    const bomKwh   = cfg.querySelector('[data-bom-kwh]');
    const bomList  = cfg.querySelector('[data-bom-list]');
    function currentSystem() {
      const selected = cfg.querySelector('input[name="system"]:checked');
      return selected ? selected.value : 'freshwater';
    }
    function currentVolume() {
      const selected = cfg.querySelector('input[name="volume"]:checked');
      return selected ? selected.value : 'nano';
    }
    // Vendor narrowing within the tank grid — a system+volume band can now hold 60-200 real
    // tanks (see tag-configurator-tanks.js), so a flat grid alone is unmanageable. Chips are
    // rebuilt on every filter pass since the available vendor set changes with system/volume.
    let cfgVendorFilter = null;
    const cfgVendorChips = cfg.querySelector('[data-cfg-vendor-chips]');
    const cfgTankCount = cfg.querySelector('[data-cfg-tank-count]');
    function applyTankVendorFilter() {
      // Called right after the system/volume pass below sets .hidden on every [data-system]
      // option — at this point a tank's .hidden already reflects system+volume only, so
      // "not hidden yet" is exactly the candidate set vendor filtering should narrow further.
      const tankOptions = [...cfg.querySelectorAll('.hv-cfg-tank[data-vendor]')]
        .filter(option => !option.hidden);
      const counts = new Map();
      tankOptions.forEach(option => {
        const vendor = option.dataset.vendor;
        counts.set(vendor, (counts.get(vendor) || 0) + 1);
      });
      if (cfgVendorFilter && !counts.has(cfgVendorFilter)) cfgVendorFilter = null;
      if (cfgVendorChips) {
        const vendors = [...counts.keys()].sort((a, b) => counts.get(b) - counts.get(a));
        if (vendors.length <= 1) {
          cfgVendorChips.innerHTML = '';
        } else {
          const chip = (label, value, count, active) => `
            <button type="button" class="hv-search-chip${active ? ' is-active' : ''}" data-cfg-vendor-value="${value ? value.replace(/"/g, '&quot;') : ''}">
              ${label}${count != null ? `<span class="hv-search-chip__count">${count}</span>` : ''}
            </button>`;
          cfgVendorChips.innerHTML = chip('Alle merken', '', null, !cfgVendorFilter) +
            vendors.map(v => chip(v, v, counts.get(v), cfgVendorFilter === v)).join('');
        }
      }
      let visible = 0;
      tankOptions.forEach(option => {
        const matches = !cfgVendorFilter || option.dataset.vendor === cfgVendorFilter;
        if (!matches) {
          option.hidden = true;
          option.querySelectorAll('input').forEach(input => input.checked = false);
        } else {
          visible++;
        }
      });
      if (cfgTankCount) {
        cfgTankCount.textContent = tankOptions.length
          ? `${visible} van ${tankOptions.length} aquariums`
          : '';
      }
    }
    if (cfgVendorChips) {
      cfgVendorChips.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-cfg-vendor-value]');
        if (!btn) return;
        cfgVendorFilter = btn.dataset.cfgVendorValue || null;
        filterConfiguratorOptions();
        cfg.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    function filterConfiguratorOptions() {
      const system = currentSystem();
      cfg.querySelectorAll('[data-volume-choice]').forEach(option => {
        const systems = (option.dataset.system || '').split(/\s+/).filter(Boolean);
        const isMatch = system !== 'custom' && (!systems.length || systems.includes(system));
        option.hidden = !isMatch;
        if (!isMatch) {
          option.querySelectorAll('input').forEach(input => input.checked = false);
        }
      });
      const checkedVolume = cfg.querySelector('input[name="volume"]:checked');
      const checkedVolumeOption = checkedVolume ? checkedVolume.closest('[data-volume-choice]') : null;
      if (!checkedVolume || (checkedVolumeOption && checkedVolumeOption.hidden)) {
        const firstVisibleVolume = [...cfg.querySelectorAll('input[name="volume"]')]
          .find(input => {
            const option = input.closest('[data-volume-choice]');
            return !option || !option.hidden;
          });
        if (firstVisibleVolume) firstVisibleVolume.checked = true;
      }
      const volume = currentVolume();
      cfg.querySelectorAll('[data-system]').forEach(option => {
        if (option.hasAttribute('data-volume-choice')) return;
        const systems = (option.dataset.system || '').split(/\s+/).filter(Boolean);
        const volumes = (option.dataset.liters || '').split(/\s+/).filter(Boolean);
        const isQuoteFlow = system === 'custom' && volumes.length;
        const isMatch = !isQuoteFlow &&
          (!systems.length || systems.includes(system)) &&
          (!volumes.length || volumes.includes(volume));
        option.hidden = !isMatch;
        if (!isMatch) {
          option.querySelectorAll('input').forEach(input => input.checked = false);
        }
      });
      applyTankVendorFilter();
      if (system === 'custom' && !cfg.querySelector('input[name="custom_type"]:checked')) {
        const firstCustomType = cfg.querySelector('input[name="custom_type"]');
        if (firstCustomType) firstCustomType.checked = true;
      }
      const checkedTank = cfg.querySelector('input[name="tank"]:checked');
      const checkedTankOption = checkedTank ? checkedTank.closest('[data-system]') : null;
      if (!checkedTank || (checkedTankOption && checkedTankOption.hidden)) {
        const firstVisibleTank = [...cfg.querySelectorAll('input[name="tank"]')]
          .find(input => {
            const option = input.closest('[data-system]');
            return !option || !option.hidden;
          });
        if (firstVisibleTank) firstVisibleTank.checked = true;
      }
    }
    const bomVisual = cfg.querySelector('[data-bom-visual]');
    const bomVisualImg = cfg.querySelector('[data-bom-visual-img]');
    const bomTitle = cfg.querySelector('[data-bom-title]');
    function updateBomVisual() {
      const checkedTank = cfg.querySelector('input[name="tank"]:checked');
      const tankCard = checkedTank ? checkedTank.closest('.hv-cfg-tank') : null;
      const img = tankCard ? tankCard.querySelector('img') : null;
      if (bomVisual && bomVisualImg) {
        if (img && img.src) {
          bomVisualImg.src = img.src;
          bomVisual.hidden = false;
        } else {
          bomVisual.hidden = true;
        }
      }
      if (bomTitle) {
        const name = tankCard ? tankCard.querySelector('h3')?.textContent : null;
        bomTitle.textContent = name || 'Wat je hebt gekozen';
      }
    }
    function recomputeBom() {
      updateBomVisual();
      let total = 0, watts = 0;
      const lines = [];
      cfg.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked').forEach(inp => {
        const price = parseFloat(inp.dataset.price || 0);
        const w     = parseFloat(inp.dataset.watts || 0);
        const label = inp.dataset.label || inp.value;
        total += price; watts += w;
        if (label && (price || inp.dataset.showInBom === 'true')) lines.push({ label, price });
      });
      if (bomList && lines.length) {
        bomList.innerHTML = lines.map(l =>
          `<li class="hv-flex hv-flex--between"><span>${escapeHtml(l.label)}</span><span class="hv-mono">${l.price ? formatMoney(l.price * 100) : 'Offerte'}</span></li>`
        ).join('');
      } else if (bomList) {
        bomList.innerHTML = '<li class="hv-text-dim">Nog niets geselecteerd — kies opties links.</li>';
      }
      if (bomTotal) bomTotal.textContent = formatMoney(total * 100);
      if (bomKwh)   bomKwh.textContent   = `≈ ${((watts * 12) / 1000).toFixed(2)} kWh/dag · ${watts}W`;
    }
    function updateQuoteMailto() {
      const quoteLink = cfg.querySelector('[data-quote-mailto]');
      if (!quoteLink) return;
      const customType = cfg.querySelector('input[name="custom_type"]:checked');
      const lines = [
        'Maatwerk offerte-aanvraag',
        '',
        `Type: ${customType ? customType.value : 'Nog niet gekozen'}`
      ];
      cfg.querySelectorAll('[data-quote-field]').forEach(field => {
        const label = field.dataset.quoteField || field.name;
        lines.push(`${label}: ${field.value || '-'}`);
      });
      lines.push('', 'Graag ontvang ik een offerte en advies voor dit project.');
      quoteLink.href = `mailto:webshop@heevis.nl?subject=${encodeURIComponent('Maatwerk offerte aanvraag')}&body=${encodeURIComponent(lines.join('\n'))}`;
    }

    // ── Determine if selected options are Shopify products (numeric variant IDs)
    function selectedVariantIds() {
      const ids = [];
      cfg.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked').forEach(inp => {
        const val = inp.value;
        // Shopify variant IDs are large numbers (> 10 digits); slugs are alphanumeric with dashes
        if (/^\d{10,}$/.test(val)) ids.push({ id: val, qty: 1 });
      });
      return ids;
    }

    // ── Show correct action buttons based on system and product source
    function updateActionButtons() {
      const system = currentSystem();
      const addToCartBtn = cfg.querySelector('[data-cfg-add-to-cart]');
      const fallbackContact = cfg.querySelector('[data-cfg-fallback-contact]');
      const quoteBtn = cfg.querySelector('[data-quote-mailto]');
      const hasProducts = selectedVariantIds().length > 0;

      // Hide all first
      if (addToCartBtn) addToCartBtn.style.display = 'none';
      if (fallbackContact) fallbackContact.style.display = 'none';
      if (quoteBtn) quoteBtn.style.display = 'none';

      if (system === 'custom') {
        if (quoteBtn) quoteBtn.style.display = '';
      } else {
        // freshwater or reef
        if (hasProducts) {
          if (addToCartBtn) addToCartBtn.style.display = '';
        } else {
          if (fallbackContact) fallbackContact.style.display = '';
        }
      }
    }

    // ── Add configurator selection to cart (AJAX)
    async function addConfiguratorToCart() {
      const items = selectedVariantIds();
      if (!items.length) return;

      const addBtn = cfg.querySelector('[data-cfg-add-to-cart]');
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Toevoegen…'; }

      try {
        // Add items one by one (Shopify /cart/add.js accepts single items)
        for (const item of items) {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: item.id, quantity: item.qty }),
          });
        }
        // Refresh cart drawer
        if (typeof refreshCart === 'function') await refreshCart();
        // Open cart drawer
        const drawer = document.querySelector('[data-cart-drawer]');
        const overlay = document.querySelector('[data-cart-overlay]');
        if (drawer) { drawer.setAttribute('aria-hidden', 'false'); drawer.hidden = false; }
        if (overlay) { overlay.setAttribute('aria-hidden', 'false'); }
      } catch (err) {
        alert('Er ging iets mis bij het toevoegen aan de winkelwagen. Probeer het opnieuw.');
        console.error(err);
      } finally {
        if (addBtn) { addBtn.disabled = false; addBtn.innerHTML = `Toevoegen aan winkelwagen <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>`; }
      }
    }

    cfg.querySelectorAll('[data-cfg-add-to-cart]').forEach(btn => {
      btn.addEventListener('click', addConfiguratorToCart);
    });

    cfg.addEventListener('change', (event) => {
      if (event.target && (event.target.name === 'system' || event.target.name === 'volume')) {
        filterConfiguratorOptions();
      }
      recomputeBom();
      updateQuoteMailto();
      updateActionButtons();
    });
    cfg.addEventListener('input', () => { updateQuoteMailto(); updateActionButtons(); });
    filterConfiguratorOptions();
    recomputeBom();
    updateQuoteMailto();
    updateActionButtons();
  }

  // ── Scroll-shadow / compact header ───────────────────────────────────────
  // A single hard threshold here used to flip the class every time scrollY crossed 80px in
  // EITHER direction — natural scroll jitter (trackpads, momentum scrolling) right around
  // that line re-triggered the ~0.35s collapse/logo-shrink transition mid-way, over and over,
  // which is what read as the header "jumping" while scrolling. Two fixes: hysteresis (enter
  // the compact state at 80px, only leave it once scrolled back up past 40px, so hovering
  // near one value can't flip it back and forth) and rAF-throttling so the class is only
  // touched once per frame instead of on every raw scroll event.
  const header = document.querySelector('.hv-header');
  if (header) {
    const ENTER_AT = 80, EXIT_AT = 40;
    let scrolled = false, ticking = false;
    const apply = () => {
      const y = window.scrollY;
      if (!scrolled && y > ENTER_AT) scrolled = true;
      else if (scrolled && y < EXIT_AT) scrolled = false;
      header.classList.toggle('hv-header--scrolled', scrolled);
      ticking = false;
    };
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(apply);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    apply();
  }

  // ── PDP: sticky floating add-to-cart ─────────────────────────────────────
  (function initPdpxSticky(){
    const sticky = document.querySelector('[data-pdpx-sticky]');
    const mainCta = document.querySelector('[data-pdp-submit]');
    if (!sticky || !mainCta) return;

    const stickyCta = sticky.querySelector('[data-pdpx-sticky-cta]');

    // Show sticky bar when the main add-to-cart button has scrolled out of view.
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        sticky.setAttribute('data-visible', entry.isIntersecting ? 'false' : 'true');
        sticky.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });
    io.observe(mainCta);

    // Proxy click: trigger the real form submit (so variant + qty are preserved).
    if (stickyCta) {
      stickyCta.addEventListener('click', () => {
        if (mainCta.disabled) return;
        mainCta.click();
      });
    }
  })();

  // ── Generic carousel (horizontal snap-scroll w/ prev-next buttons) ───────
  document.querySelectorAll('[data-carousel]').forEach(root => {
    const track = root.querySelector('[data-carousel-track]');
    const prev = root.querySelector('[data-carousel-prev]');
    const next = root.querySelector('[data-carousel-next]');
    if (!track) return;

    const step = () => {
      const slide = track.querySelector('.hv-carousel__slide');
      if (!slide) return track.clientWidth * 0.8;
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return slide.getBoundingClientRect().width + gap;
    };

    const update = () => {
      const maxScroll = track.scrollWidth - track.clientWidth - 2;
      const overflows = maxScroll > 0;
      if (!overflows) {
        if (prev) prev.hidden = true;
        if (next) next.hidden = true;
        return;
      }
      if (prev) prev.hidden = track.scrollLeft <= 4;
      if (next) next.hidden = track.scrollLeft >= maxScroll;
    };

    prev && prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next && next.addEventListener('click', () => track.scrollBy({ left:  step(), behavior: 'smooth' }));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  // ── Footer: back-to-top ───────────────────────────────────────────────────
  document.querySelectorAll('[data-back-to-top]').forEach(btn => {
    btn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });

  // ── Footer: country selector (auto-submit on change) ─────────────────────
  document.querySelectorAll('.hv-footer__locale select').forEach(sel => {
    sel.addEventListener('change', () => sel.form && sel.form.submit());
  });

  // ── Wishlist (localStorage stub) ──────────────────────────────────────────
  const WL_KEY = 'hv-wishlist';
  function getWL() { try { return JSON.parse(localStorage.getItem(WL_KEY) || '[]'); } catch { return []; } }
  function setWL(arr) { localStorage.setItem(WL_KEY, JSON.stringify(arr)); updateWLCount(); paintWLToggles(); }
  function updateWLCount() {
    const n = getWL().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(el => {
      el.textContent = n; el.hidden = n === 0;
    });
  }
  function paintWLToggles() {
    const wl = getWL();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
      const has = wl.includes(btn.dataset.productHandle);
      btn.setAttribute('aria-pressed', has ? 'true' : 'false');
      btn.style.color = has ? 'var(--hv-danger)' : '';
    });
  }
  document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
    btn.addEventListener('click', () => {
      const wl = getWL();
      const h = btn.dataset.productHandle;
      const i = wl.indexOf(h);
      if (i >= 0) wl.splice(i, 1); else wl.push(h);
      setWL(wl);
    });
  });
  paintWLToggles(); updateWLCount();
  window.HVWishlist = { get: getWL, has: (h) => getWL().includes(h), toggle: (h) => {
    const wl = getWL(); const i = wl.indexOf(h); if (i >= 0) wl.splice(i,1); else wl.push(h); setWL(wl);
  }};

  // ── Terugknop op collectiepagina's ─────────────────────────────────────────
  // Per tabblad een spoor van bezochte collectiepagina's (sessionStorage). De knop gaat naar de
  // collectie waar je vandaan kwam. Query's (filters, ?page=2) tellen niet mee: het pad is de pagina.
  // Gebruik je onze knop, dan wordt het spoor tot dat doel ingekort, anders ping-pong je tussen twee
  // collecties. De pure stap staat tussen markers zodat test-collection-trail.js hem kan uitvoeren.
  // <trail-step>
  function hvTrailStep(trail, flag, here) {
    let t = Array.isArray(trail) ? trail.filter((x) => x && x.url) : [];
    if (flag) { const i = t.map((x) => x.url).lastIndexOf(flag); if (i >= 0) t = t.slice(0, i + 1); }
    const first = t.findIndex((x) => x.url === here.url);
    if (first >= 0) t = t.slice(0, first + 1); else t.push(here);
    t = t.slice(-12);
    return { trail: t, prev: t.length > 1 ? t[t.length - 2] : null };
  }
  // </trail-step>
  (function () {
    const el = document.querySelector('[data-hv-back]');
    if (!el) return;
    const label = el.querySelector('[data-hv-back-label]');
    const KEY = 'hv-trail', FLAG = 'hv-back-target';
    const here = { url: el.dataset.hereUrl, title: el.dataset.hereTitle || el.dataset.hereUrl };
    let trail = [], flag = null;
    try { trail = JSON.parse(sessionStorage.getItem(KEY) || '[]'); flag = sessionStorage.getItem(FLAG); sessionStorage.removeItem(FLAG); } catch (e) { /* geen opslag: dan blijft de menu-ouder */ }
    const r = hvTrailStep(trail, flag, here);
    try { sessionStorage.setItem(KEY, JSON.stringify(r.trail)); } catch (e) { /* idem */ }
    if (r.prev) { el.href = r.prev.url; if (label) label.textContent = 'Terug naar ' + r.prev.title; el.hidden = false; }
    el.addEventListener('click', () => { try { sessionStorage.setItem(FLAG, el.getAttribute('href')); } catch (e) { /* idem */ } });
  })();

  // ── Cookie-instellingen heropenen (Usercentrics via GTM) ──────────────────
  // Onze eigen cookiemelding is eruit; Usercentrics wordt via Google Tag Manager geladen.
  // De footerknop blijft verborgen zolang UC_UI er niet is, zodat er geen knop staat die
  // niets doet — bijvoorbeeld als GTM geblokkeerd wordt door een adblocker.
  (function () {
    const links = document.querySelectorAll('[data-cookie-settings]');
    if (!links.length) return;
    function beschikbaar() { return !!(window.UC_UI && typeof window.UC_UI.showSecondLayer === 'function'); }
    function sync() { const ok = beschikbaar(); links.forEach((l) => { l.hidden = !ok; }); return ok; }
    links.forEach((l) => l.addEventListener('click', (e) => {
      e.preventDefault();
      if (beschikbaar()) window.UC_UI.showSecondLayer();
    }));
    if (!sync()) {
      let pogingen = 0;
      const t = setInterval(() => { if (sync() || (pogingen += 1) > 30) clearInterval(t); }, 500);
    }
  })();

  // ── Cookie consent ────────────────────────────────────────────────────────
  // Replaces the old accept/decline pair, which set Shopify's consent as one boolean —
  // so "alleen functioneel" still switched off analytics the shop is allowed to run, and
  // accepting granted marketing without asking. Consent is per category now, re-applied on
  // every page load (Shopify's API keeps its own cookie, but a stale or cleared one would
  // otherwise silently downgrade a choice the visitor already made).
  const ck = document.querySelector('[data-cookie-banner]');
  if (ck) {
    const STORE_KEY = 'hv-consent';
    const VERSION = 1;              // bump to ask everyone again
    const MAX_AGE_DAYS = 365;       // re-ask after a year, as consent guidance expects
    const CATS = ['preferences', 'analytics', 'marketing'];

    const read = () => {
      try {
        const raw = JSON.parse(localStorage.getItem(STORE_KEY) || 'null');
        if (!raw || raw.v !== VERSION) return null;
        if (Date.now() - raw.at > MAX_AGE_DAYS * 864e5) return null;
        return raw;
      } catch (e) { return null; }
    };
    const write = (choice) => {
      try { localStorage.setItem(STORE_KEY, JSON.stringify({ v: VERSION, at: Date.now(), c: choice })); } catch (e) {}
    };

    // Shopify exposes the consent API only after the feature is loaded; without it the
    // choice is still stored locally, so nothing hangs on this resolving.
    function withPrivacy(cb) {
      if (window.Shopify && window.Shopify.customerPrivacy) return cb(window.Shopify.customerPrivacy);
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {
          if (window.Shopify.customerPrivacy) cb(window.Shopify.customerPrivacy);
        });
      }
    }
    function applyConsent(choice) {
      withPrivacy((api) => {
        try {
          api.setTrackingConsent({
            preferences: !!choice.preferences,
            analytics: !!choice.analytics,
            marketing: !!choice.marketing,
            sale_of_data: !!choice.marketing,
          }, () => {});
        } catch (e) {
          // Older shops only accept the boolean form.
          try { api.setTrackingConsent(!!choice.analytics || !!choice.marketing, () => {}); } catch (e2) {}
        }
      });
      document.dispatchEvent(new CustomEvent('hv:consent', { detail: choice }));
    }

    const backdrop = ck.querySelector('[data-cookie-backdrop]');
    const views = {
      intro: ck.querySelector('[data-cookie-view="intro"]'),
      prefs: ck.querySelector('[data-cookie-view="prefs"]'),
    };
    function show(view) {
      views.intro.hidden = view !== 'intro';
      views.prefs.hidden = view !== 'prefs';
      if (backdrop) backdrop.hidden = view !== 'prefs';
      ck.classList.toggle('hv-cookie--prefs', view === 'prefs');
      ck.hidden = false;
      requestAnimationFrame(() => ck.classList.add('hv-cookie--in'));
    }
    function hide() {
      ck.classList.remove('hv-cookie--in');
      setTimeout(() => { ck.hidden = true; if (backdrop) backdrop.hidden = true; }, 250);
    }
    function decide(choice) {
      write(choice);
      applyConsent(choice);
      hide();
    }
    function switches() { return [...ck.querySelectorAll('[data-cookie-cat]')]; }
    function fillSwitches(choice) {
      switches().forEach((el) => { el.checked = !!choice[el.dataset.cookieCat]; });
    }
    function readSwitches() {
      const out = {};
      CATS.forEach((c) => { out[c] = false; });
      switches().forEach((el) => { out[el.dataset.cookieCat] = el.checked; });
      return out;
    }

    const all = { preferences: true, analytics: true, marketing: true };
    const none = { preferences: false, analytics: false, marketing: false };

    ck.querySelectorAll('[data-cookie-accept-all]').forEach((b) => b.addEventListener('click', () => decide(all)));
    ck.querySelectorAll('[data-cookie-reject]').forEach((b) => b.addEventListener('click', () => decide(none)));
    ck.querySelectorAll('[data-cookie-save]').forEach((b) => b.addEventListener('click', () => decide(readSwitches())));
    ck.querySelectorAll('[data-cookie-open-prefs]').forEach((b) => b.addEventListener('click', () => {
      fillSwitches(read() ? read().c : none);
      show('prefs');
    }));
    // Backing out of preferences: someone who has already chosen is done, someone who
    // hasn't still needs to answer the banner.
    function backOut() { if (read()) hide(); else show('intro'); }
    if (backdrop) backdrop.addEventListener('click', backOut);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !ck.hidden && ck.classList.contains('hv-cookie--prefs')) backOut();
    });

    // Re-open from anywhere (footer link, privacy page).
    document.querySelectorAll('[data-cookie-settings]').forEach((el) => el.addEventListener('click', (e) => {
      e.preventDefault();
      fillSwitches(read() ? read().c : none);
      show('prefs');
    }));

    const stored = read();
    if (stored) applyConsent(stored.c);
    else show('intro');
  }

  // ── Newsletter pop-up ────────────────────────────────────────────────────
  const nlp = document.querySelector('[data-newsletter-popup]');
  if (nlp) {
    // Versie in de sleutel: zet het versienummer in de theme-instellingen een hoger getal en
    // iedereen krijgt de pop-up opnieuw te zien. Zonder dat kon een campagne nooit herhaald
    // worden — wie hem één keer wegklikte, zag hem nooit meer.
    const POPUP_VERSION = nlp.dataset.newsletterPopupVersion || '1';
    const MAX_AGE_DAYS = parseInt(nlp.dataset.newsletterPopupDays, 10) || 0;
    const SEEN_KEY = `hv-newsletter-popup-seen-v${POPUP_VERSION}`;
    function dismiss() {
      try { localStorage.setItem(SEEN_KEY, String(Date.now())); } catch (e) {}
      nlp.removeAttribute('data-open');
      setTimeout(() => { nlp.hidden = true; }, 260); // matches the CSS fade-out duration
    }
    let seen = false;
    try {
      const at = parseInt(localStorage.getItem(SEEN_KEY), 10);
      seen = !!at;
      if (at && MAX_AGE_DAYS && (Date.now() - at) > MAX_AGE_DAYS * 864e5) seen = false;
    } catch (e) {}
    if (!seen) {
      const delay = (parseInt(nlp.dataset.newsletterPopupDelay, 10) || 5) * 1000;
      setTimeout(() => {
        nlp.hidden = false;
        requestAnimationFrame(() => nlp.setAttribute('data-open', ''));
      }, delay);
    }
    nlp.querySelectorAll('[data-newsletter-popup-close]').forEach((el) => el.addEventListener('click', dismiss));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && nlp.hasAttribute('data-open')) dismiss(); });
    // A successful subscribe is as good a reason as any close button to never show it again.
    const form = nlp.querySelector('.hv-newsletter-form');
    if (form) form.addEventListener('submit', () => { setTimeout(dismiss, 1800); });
  }

  // ── Quick add (from cards) ───────────────────────────────────────────────
  document.querySelectorAll('[data-quick-add]').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault(); e.stopPropagation();
      const id = btn.dataset.variantId; if (!id) return;
      btn.disabled = true; const orig = btn.innerHTML; btn.textContent = '…';
      try {
        await fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id, quantity: 1 }),
        });
        openCart();
      } catch (err) { console.warn(err); }
      finally { btn.disabled = false; btn.innerHTML = orig; }
    });
  });

  // ── Sticky mobile CTA ─────────────────────────────────────────────────────
  const stickyCta = document.querySelector('[data-sticky-cta]');
  if (stickyCta) {
    const stickyAdd   = stickyCta.querySelector('[data-sticky-add]');
    const stickyPrice = stickyCta.querySelector('[data-sticky-price]');
    const mainAdd     = document.querySelector('[data-pdp-submit]');
    function onScroll() {
      if (!mainAdd) { stickyCta.classList.add('is-in'); return; }
      const r = mainAdd.getBoundingClientRect();
      const past = r.bottom < 0 || r.top > window.innerHeight;
      stickyCta.classList.toggle('is-in', past);
      stickyCta.setAttribute('aria-hidden', past ? 'false' : 'true');
    }
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    if (stickyAdd) {
      stickyAdd.addEventListener('click', async () => {
        const hiddenId = document.querySelector('input[name="id"]');
        const id = (hiddenId && hiddenId.value) || stickyAdd.dataset.variantId;
        if (!id) return;
        stickyAdd.disabled = true;
        try {
          await fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type':'application/json', Accept:'application/json' },
            body: JSON.stringify({ id, quantity: 1 })
          });
          toast('Toegevoegd aan winkelwagen'); openCart();
        } finally { stickyAdd.disabled = false; }
      });
    }
    // Update sticky price when variant changes
    document.addEventListener('hv:variant-change', (e) => {
      if (stickyPrice && e.detail && e.detail.price != null) {
        stickyPrice.textContent = formatMoney(e.detail.price);
      }
      if (stickyAdd && e.detail && e.detail.id) {
        stickyAdd.dataset.variantId = e.detail.id;
      }
    });
  }

  // ── Size guide modal ──────────────────────────────────────────────────────
  let releaseGuideTrap;
  document.querySelectorAll('[data-size-guide-open]').forEach(btn => {
    btn.addEventListener('click', () => {
      const m = document.querySelector('[data-size-guide]');
      if (!m) return;
      m.setAttribute('aria-hidden', 'false'); document.body.classList.add('hv-locked');
      releaseGuideTrap = trapFocus(m);
    });
  });
  document.querySelectorAll('[data-size-guide-close]').forEach(btn => {
    btn.addEventListener('click', () => {
      const m = document.querySelector('[data-size-guide]');
      if (!m) return;
      m.setAttribute('aria-hidden', 'true'); document.body.classList.remove('hv-locked');
      if (releaseGuideTrap) releaseGuideTrap();
    });
  });

  // ── Recently viewed (localStorage) ────────────────────────────────────────
  const RV_KEY = 'hv-recently-viewed';
  function getRV() { try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch { return []; } }
  function setRV(arr) { localStorage.setItem(RV_KEY, JSON.stringify(arr.slice(0, 12))); }
  // Track current product page
  const productInfo = document.querySelector('[data-product-info]');
  if (productInfo) {
    const handle = productInfo.dataset.productHandle;
    if (handle) {
      const list = getRV().filter(h => h !== handle);
      list.unshift(handle);
      setRV(list);
    }
  }
  // Render
  const rvSection = document.querySelector('[data-recently-viewed]');
  if (rvSection) {
    const grid = rvSection.querySelector('[data-recently-viewed-grid]');
    const currentHandle = productInfo ? productInfo.dataset.productHandle : null;
    const handles = getRV().filter(h => h !== currentHandle).slice(0, 4);
    if (handles.length === 0) { rvSection.hidden = true; }
    else {
      Promise.all(handles.map(h => fetch(`/products/${h}.js`, { headers: { Accept: 'application/json' } })
        .then(r => r.ok ? r.json() : null).catch(() => null)))
        .then(items => {
          const valid = items.filter(Boolean);
          if (!valid.length) { rvSection.hidden = true; return; }
          rvSection.hidden = false;
          grid.innerHTML = valid.map(p => `
            <a href="${p.url}" class="hv-product-card">
              <div class="hv-product-card__media">
                ${p.featured_image ? `<img src="${p.featured_image}" alt="${escapeHtml(p.title)}" loading="lazy" style="position:absolute;inset:0;width:100%;height:100%;object-fit:contain;background:#fff">`
                  : '<div class="hv-noimg hv-noimg--fill" role="img" aria-label="Foto volgt"></div>'}
              </div>
              <div class="hv-product-card__body">
                <h3 class="hv-product-card__title">${escapeHtml(p.title)}</h3>
                <div class="hv-product-card__price"><span class="price">${formatMoney(p.price)}</span></div>
              </div>
            </a>
          `).join('');
        });
    }
  }

  // ── Estimated delivery date — "Bestel binnen Xh Ym voor levering morgen" ──
  const etaHint = document.querySelector('[data-eta-hint]');
  if (etaHint) {
    function tickEta() {
      const headline = etaHint.querySelector('[data-eta-headline]');
      if (!headline) return;
      const now = new Date();
      // Cutoff = today 14:00 — if past, message shifts to "Bestel vandaag voor levering overmorgen"
      const cutoff = new Date(now); cutoff.setHours(14, 0, 0, 0);
      let diffMs = cutoff - now;
      let dayLabel = 'morgen';
      if (diffMs < 0) {
        cutoff.setDate(cutoff.getDate() + 1); diffMs = cutoff - now;
        dayLabel = 'overmorgen';
      }
      // Weekend handling — next-day shifts
      const deliveryDay = new Date(cutoff); deliveryDay.setDate(deliveryDay.getDate() + 1);
      if (deliveryDay.getDay() === 0) deliveryDay.setDate(deliveryDay.getDate() + 1); // Sun → Mon
      if (deliveryDay.getDay() === 6) deliveryDay.setDate(deliveryDay.getDate() + 2); // Sat → Mon
      const days = ['zondag','maandag','dinsdag','woensdag','donderdag','vrijdag','zaterdag'];
      dayLabel = days[deliveryDay.getDay()];
      const h = Math.floor(diffMs / 3600000);
      const m = Math.floor((diffMs % 3600000) / 60000);
      headline.textContent = `Bestel binnen ${h}u ${m}m voor levering ${dayLabel}`;
    }
    tickEta(); setInterval(tickEta, 30000);
  }

  // Emit variant-change event for sticky CTA / other listeners
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-pdp-opt]');
    if (!btn) return;
    setTimeout(() => {
      const hidden = document.querySelector('input[name="id"]');
      const price = document.querySelector('[data-pdp-price]');
      if (!hidden) return;
      const evt = new CustomEvent('hv:variant-change', {
        detail: { id: hidden.value, price: price ? (price.dataset.priceCents ? Number(price.dataset.priceCents) : parsePrice(price.textContent)) : null }
      });
      document.dispatchEvent(evt);
    }, 50);
  });
  function parsePrice(s) {
    const m = String(s).replace(/[^\d,.-]/g, '').replace(',', '.');
    return Math.round(parseFloat(m) * 100);
  }

  // ── Wishlist toast feedback ──────────────────────────────────────────────
  document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
    btn.addEventListener('click', () => {
      // Painted state is set by the existing handler — we layer toast after
      setTimeout(() => {
        const on = btn.getAttribute('aria-pressed') === 'true';
        toast(on ? 'Toegevoegd aan wishlist ♥' : 'Verwijderd van wishlist');
      }, 20);
    });
  });

  // ── Price range slider ────────────────────────────────────────────────────
  document.querySelectorAll('[data-price-range]').forEach(scope => {
    const rmin = parseFloat(scope.dataset.rangeMin);
    const rmax = parseFloat(scope.dataset.rangeMax);
    const minInput = scope.querySelector('[data-range-min-input]');
    const maxInput = scope.querySelector('[data-range-max-input]');
    const fill = scope.querySelector('[data-range-fill]');
    const minLbl = scope.parentElement.querySelector('[data-range-min-display]');
    const maxLbl = scope.parentElement.querySelector('[data-range-max-display]');
    function update() {
      let lo = parseFloat(minInput.value), hi = parseFloat(maxInput.value);
      if (lo > hi - 5) { lo = hi - 5; minInput.value = lo; }
      const lp = ((lo - rmin) / (rmax - rmin)) * 100;
      const rp = ((hi - rmin) / (rmax - rmin)) * 100;
      fill.style.left = lp + '%'; fill.style.right = (100 - rp) + '%'; fill.style.width = 'auto';
      if (minLbl) minLbl.textContent = '€' + lo;
      if (maxLbl) maxLbl.textContent = '€' + hi;
    }
    minInput.addEventListener('input', update); maxInput.addEventListener('input', update); update();
  });

  // Initial cart count sync
  refreshCart();
})();

// ── Scroll-reveal system ──────────────────────────────────────────────────────
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Selectors that receive auto-reveal (in order from top to bottom of the page)
  const GRID_SELECTORS = [
    '.hv-product-card',
    '.hv-card:not(.hv-cfg-opt):not(.hv-cfg-tank)',
    '.hv-trust__item',
    '.hv-brand-logo',
    '.hv-community__tile',
    '.hv-review-card',
    '.hv-pdpx__welfare-card',
  ];
  const SOLO_SELECTORS = [
    '.hv-eyebrow',
    '.hv-drops__heading',
    '.hv-section-heading',
    '.hv-bundle-banner',
    '.hv-coral-editorial__mosaic',
    '.hv-before-after',
    '.hv-reptiles__visual',
  ];

  // Detect if element is likely above-the-fold on load
  function aboveFold(el) {
    return el.getBoundingClientRect().top < window.innerHeight * 0.15;
  }

  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('hv-revealed');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

  function registerEl(el, type, delay) {
    if (aboveFold(el)) return; // never hide above-fold content
    if (el.dataset.reveal) return; // already registered
    el.dataset.reveal = type;
    if (delay) el.dataset.revealDelay = String(delay);
    io.observe(el);
  }

  // Register grid items with stagger
  GRID_SELECTORS.forEach(sel => {
    document.querySelectorAll(sel).forEach((el, i) => {
      registerEl(el, 'up', Math.min((i % 6) + 1, 6));
    });
  });

  // Register solo elements
  SOLO_SELECTORS.forEach(sel => {
    document.querySelectorAll(sel).forEach(el => registerEl(el, 'fade'));
  });

  // Also pick up h2 inside sections (but not hero)
  document.querySelectorAll(
    'section:not(.hv-hero) h2, section:not(.hv-hero) h3:not(.hv-product-card__title)'
  ).forEach(el => registerEl(el, 'up'));

  // ── Product-card video (opt-in playback) ──────────────────────────────────
  // Cards render <video preload="none"> without autoplay. Start playback only on
  // hover (pointer devices), so a 24-card grid never fetches 24 videos at once.
  (function () {
    const vids = document.querySelectorAll('[data-card-video]');
    if (!vids.length) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const canHover = window.matchMedia('(hover: hover)').matches;
    if (reduced || !canHover) return; // touch/reduced-motion: poster only

    vids.forEach(v => {
      const card = v.closest('.hv-product-card') || v.parentElement;
      if (!card) return;
      card.addEventListener('mouseenter', () => {
        if (!v.dataset.loaded) { v.load(); v.dataset.loaded = '1'; }
        const p = v.play();
        if (p && p.catch) p.catch(() => {});
      });
      card.addEventListener('mouseleave', () => { v.pause(); });
    });
  })();

})();
